module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._l((this.content), function(x) {
    return _c('el-card', {
      key: x.id,
      staticClass: "box-card-component",
      style: (_vm.bodystyle(x.hotnews))
    }, [_c('div', {
      staticClass: "box-card-header",
      attrs: {
        "xslot": "header"
      }
    }, [_c('h1', [(x.hotnews) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("HOT NEWS: ")]) : _vm._e(), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(x.newstitle)
      }
    }), _c('br'), _vm._v(" "), _c('center', [(x.id == 0) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "small",
        "xicon": "el-icon-edit"
      },
      on: {
        "click": function($event) {
          return _vm.OpenMoreNews()
        }
      }
    }, [_vm._v("Other News")]) : _vm._e()], 1)], 1)]), _vm._v(" "), (x.id > 0) ? _c('div', [(x.newsimage != '') ? _c('img', {
      staticStyle: {
        "float": "right",
        "width": "250px",
        "margin-bottom": "20px"
      },
      attrs: {
        "src": x.newsimage
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(x.newstext)
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "break": "both",
        "font-size": "10px",
        "float": "right",
        "margin-bottom": "5px",
        "clear": "both"
      }
    }, [_vm._v("Created: " + _vm._s(x.newscreated) + " By: " + _vm._s(x.newsby))])]) : _vm._e()])
  }), _vm._v(" "), _vm._m(0)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "20px"
    }
  }, [_vm._v("\n    This site is intended for internal use only."), _c('br'), _c('br'), _vm._v("\n    For more information, bugs or additional support, please contact "), _c('a', {
    attrs: {
      "href": "mailto:ruud.noordermeer@tui.nl"
    }
  }, [_vm._v("ruud.noordermeer@tui.nl")]), _vm._v(" or\n    "), _c('a', {
    attrs: {
      "href": "mailto:Joeri.Bossuyt@tui.be"
    }
  }, [_vm._v("Joeri.Bossuyt@tui.be")]), _vm._v("."), _c('br'), _c('br'), _vm._v("\n    Thanks for your time!"), _c('br'), _c('br'), _vm._v("\n    Last Modified: 2022-11-16"), _c('br'), _vm._v("\n    By team: TUI Western Region Delivery (WRD)\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19c6c89c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Main.vue
// module id = 634
// module chunks = 1